module.exports = __webpack_public_path__ + "media/images/flags/sv-173da534ba6477fb5d8c5cd5e2158f75.svg";